export class GmsFavorite {
    constructor(gmsId: string, sortOrder: number) {
        this.gmsId = gmsId;
        this.sortOrder = sortOrder;
    }
    gmsId: string;
    sortOrder: number;
}